import { http } from "api/http";

interface CreateFolder {
  name: string;
  clientId?: string | null;
  clientGroup?: string | null;
  parent: string | null;
  type: "organization" | "client" | "task" | "clientGroup" | "vcloud-storage";
}

interface GetStorage {
  folderId: string | null;
  clientId: string;
  search?: string;
}

const createFolder = (data: CreateFolder) => {
  return http.post("/storage/create-folder", data);
};

const uploadFile = (data: any) => {
  return http.post("/storage/upload-file", data);
  // return http.post("/onedrive/upload-file", data);
};

const uploadandStoreFile = (data: any) => {
  return http.post("/storage/upload-and-store-file", data);
  // return http.post("/onedrive/upload-file", data);
};


const uploadFiles = (data: any) => {
  return http.post("/storage/upload-files", data);
  // return http.post("/onedrive/upload-files", data);
};

const createLink = (data: any) => {
  return http.post("/storage/create-link", data);
};

const moveFile = (data: any) => {
  return http.put(`/storage/move-file`, data);
};

const getStorage = ({ queryKey }: any) => {
  const params: GetStorage = queryKey[1];
  return http.get("/storage", { params });
};

const getTotalStorage = ({ queryKey }: any) => {
  const clientId = queryKey[1];
  const clientGroupId = queryKey[2];
  return http.get("/storage/total-storage", { params: { clientId, clientGroupId } });
};

const searchStorage = (params: any) => {
  return http.get("/storage", { params });
};

const getStorageTree = ({ queryKey }: any) => {
  return http.get("/storage/tree", { params: { clientId: queryKey[1] } });
};

const renameFile = (data: any) => {
  return http.post("/storage/rename-file", data);
};

const removeFile = (id: number) => {
  return http.delete(`/storage/remove-file/${id}`);
};
const removecollectFile = (id: number) => {
  return http.delete(`/storage/remove-collect-file/${id}`);
};


const replaceFileOrFolder = (data: any) => {
  return http.post(`/storage/replace`, data);
};

const keepBothFilesOrFolders = (data: any) => {
  return http.post(`/storage/keep-both`, data);
};

const getOrgStorage = ({ queryKey }) => {
  return http.get("/storage/org-total", { params: { ...queryKey[1] } });
};

const deleteAwsFile = (id: string) => {
  return http.delete(`/storage/delete/${id}`);
}

const addB3Credentials = (data: any) => {
  return http.post("/storage/bharath-credentials", data);
};

const getBharathCloudItems = ({ queryKey }) => {

  return http.get("/storage/bharathcloud-items", { params: { ...queryKey[1] } });
};

const getRequestDocuments = ({ queryKey }) => {
  const [, params] = queryKey;
  console.log(params, "params");
  return http.get("/storage/request-documents", { params });
};

const sendFileViaWhatsapp = (id: number | string) => {
  return http.post(`/storage/send-whatsapp/${id}`);
};

export {
  createFolder,
  getStorage,
  uploadFile,
  moveFile,
  getStorageTree,
  renameFile,
  removeFile,
  searchStorage,
  replaceFileOrFolder,
  keepBothFilesOrFolders,
  getTotalStorage,
  createLink,
  getOrgStorage,
  uploadFiles,
  deleteAwsFile,
  addB3Credentials,
  getBharathCloudItems,
  removecollectFile,
  uploadandStoreFile,
  getRequestDocuments,
  sendFileViaWhatsapp
};
